<template>
  <footer class="bg-gray-900 text-white">
    <div class="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col md:flex-row justify-between items-center">
        <p class="text-gray-300 text-sm">
          © {{ currentYear }} Royale Harmonie l'Émulation de Stavelot. Tous droits réservés.
        </p>
        <p class="text-gray-400 text-xs mt-2 md:mt-0">
          F-S S.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>
